/**
 * Classe que faz o controle do grid para atualizar os dados.
 * @author: adalto.junior
 * Date: 26/10/13
 * Time: 14:06
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ControlUpdate = function () {

    var _entityToNamespace = null;
    var _pages = [];
    var TIME_TO_EXECUTE = 300;

    this.getPages = function () {

        return _pages;

    };

    this.resetPages = function () {
        _pages = [];
    };

    this.setEntityToNamespace = function (entityToNamespace) {
        _entityToNamespace = entityToNamespace;
    };

    this.addPages = function (page) {

        var last = _pages.length -1 ;
        var lastPage = _pages[last];

        if (lastPage) {

            lastPage.endPositionPage = page.initPositionPage;
            _pages[last] = lastPage;

        }

        _pages.push(page);

    };

    this.addPageToControlUpdate = function (entity, firstResult) {

        var updaterInstance = App.Forms[entity].controlUpdater;
        var scrollInstance = App.Forms[entity].table.getObjectScroll();

        var page = {
            initPositionPage: scrollInstance.newPage,
            firstResult: firstResult
        };

        updaterInstance.addPages(page);

    };

    this.initialPage = function (entity) {

        var updaterInstance = App.Forms[entity].controlUpdater;

        var page = {
            initPositionPage: 0,
            firstResult: 0
        };

        updaterInstance.addPages(page);

    };

    this.getPageByScrollPosition = function () {

        var scrollInstance = App.Forms[_entityToNamespace].table.getObjectScroll();
        var page = 0;

        var pagesSize = _pages.length;

        for (var i = 0; i < pagesSize; i++) {

            if (scrollInstance.lastScrollTop >= _pages[i].initPositionPage
                && scrollInstance.lastScrollTop < _pages[i].endPositionPage) {

                page = i;
                break;

            } else if (i === (pagesSize - 1)) {
                page = i;
            }

        }

        return page;

    };

    this.getFirstResultByScrollPosition = function () {

        var page = this.getPageByScrollPosition();
        var pages = this.getPages();
        var firstResult = 0;

        if (page !== 0){

            firstResult = pages[page].firstResult;

        }

        return firstResult;

    };

    this.updateDataToGrid = function (entity, columns, result) {

        var grid = App.Forms[entity].table;
        var dataProvider = grid.getData();
        var dataFormatted;
        var lentgh = 0;

        dataFormatted = Monet.Grid.formatDataFromCollection(columns, result, entity);
        lentgh =  dataFormatted.length;

        if (lentgh) {

            Monet.Grid.Utils.hideGridNoResult(entity);

            for (var i = 0; i < dataFormatted.length; i++) {

                var id = dataFormatted[i].id;
                var item = dataFormatted[i];

                if (dataProvider.getItemById(id)) {

                    dataProvider.updateItem(id, item);

                } else {

                    dataProvider.addItem(item);

                }

            }

            grid.invalidateAllRows();
            grid.render();

        }

    };

    this.executeUpdateAfterScroll = function (context) {

        return function (event, grid, callback) {

            var scrollInstance = App.Forms[_entityToNamespace].table.getObjectScroll();
            var actualPage = context.getPageByScrollPosition();
            var lastPage = _pages.length -1;
            var router = App.Objects[_entityToNamespace];
            var previousPage = scrollInstance.previousPage;

            if (actualPage < lastPage && actualPage !== previousPage) {

                var action = 'update';
                var filter;

                if (router.getFilter) {
                    filter = router.getFilter();
                }

                if (callback) {

                    callback();

                } else {

                    router.updateGrid(filter, this.updateDataToGrid, false, action);

                }

            }

            scrollInstance.previousPage = actualPage;

        };

    }(this);

    let timeoutId;
    this.updateAfterScroll = () => {
        timeoutId && clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            this.executeUpdateAfterScroll
        }, TIME_TO_EXECUTE);
    }

};
